import { makeAutoObservable } from "mobx";
import { format } from "date-fns";

export interface ICreditCard {
    brand: string;
    expMonth: number;
    expYear: number;
    last4: string;
}

export class CreditCard implements ICreditCard {
    brand: string;
    expMonth: number;
    expYear: number;
    last4: string;

    constructor(card: ICreditCard) {
        makeAutoObservable(this);

        this.brand = card.brand;
        this.expMonth = card.expMonth;
        this.expYear = card.expYear;
        this.last4 = card.last4;
    }

    get cardExpiration() {
        return format(new Date(this.expYear, this.expMonth - 1), "MM/yy");
    }
}